// ResumenSidebarXL - Sprint 44 Fase 3 Vista 10.
// Sidebar derecho sticky con resumen de la importacion.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLBadge from '../../../components/xl/XLBadge';
import {
  TIPOS, ESTADO_VARIANT,
  fmtCop, fmtUsd,
  showTracking, showGuia,
} from '../utils';

const CSS_ID = 'xl-imp-resumen-css';
const CSS = `
.xl-imp-res {
  background: var(--xl-color-surface);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-lg);
  box-shadow: var(--xl-shadow-sm);
  padding: 16px;
  position: sticky; top: 16px;
  font-family: var(--xl-font-sans);
}
.xl-imp-res__title {
  font-size: 11px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--xl-color-text-muted); margin-bottom: 10px;
}
.xl-imp-res__row { display: flex; flex-direction: column; gap: 2px; padding: 6px 0 }
.xl-imp-res__row + .xl-imp-res__row { border-top: 1px solid var(--xl-color-border) }
.xl-imp-res__lbl {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em;
  color: var(--xl-color-text-muted);
}
.xl-imp-res__val { font-size: 13px; color: var(--xl-color-text) }
.xl-imp-res__mono { font-family: var(--xl-font-mono); font-weight: 600 }
.xl-imp-res__total-cop { color: var(--xl-color-success) }
.xl-imp-res__break { word-break: break-all }
`;

export default function ResumenSidebarXL({ form, courierSeleccionado }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);
  const t = form.tipo_importacion;
  const tipoMeta = TIPOS.find((x) => x.k === t);
  const estVariant = ESTADO_VARIANT[form.estado] || 'neutral';

  return (
    <aside className="xl-imp-res" aria-label="Resumen de la importacion">
      <div className="xl-imp-res__title">Resumen</div>

      <div className="xl-imp-res__row">
        <span className="xl-imp-res__lbl">Referencia</span>
        <span className="xl-imp-res__val xl-imp-res__mono">
          {form.referencia || '\u2014'}
        </span>
      </div>
      <div className="xl-imp-res__row">
        <span className="xl-imp-res__lbl">Tipo</span>
        <span className="xl-imp-res__val">{tipoMeta ? tipoMeta.label : t}</span>
      </div>
      <div className="xl-imp-res__row">
        <span className="xl-imp-res__lbl">Estado</span>
        <span>
          <XLBadge variant={estVariant} dot>{form.estado}</XLBadge>
        </span>
      </div>
      <div className="xl-imp-res__row">
        <span className="xl-imp-res__lbl">Total USD</span>
        <span className="xl-imp-res__val xl-imp-res__mono">{fmtUsd(form.total_usd)}</span>
      </div>
      <div className="xl-imp-res__row">
        <span className="xl-imp-res__lbl">Total COP</span>
        <span className="xl-imp-res__val xl-imp-res__mono xl-imp-res__total-cop">
          {fmtCop(form.total_cop)}
        </span>
      </div>
      {showTracking(t) && form.courier_tracking && (
        <div className="xl-imp-res__row">
          <span className="xl-imp-res__lbl">Tracking</span>
          <span className="xl-imp-res__val">
            {courierSeleccionado && (
              <div style={{ fontWeight: 500, marginBottom: 2 }}>{courierSeleccionado.nombre}</div>
            )}
            <span className="xl-imp-res__mono xl-imp-res__break">{form.courier_tracking}</span>
          </span>
        </div>
      )}
      {showGuia(t) && form.guia_aerea && (
        <div className="xl-imp-res__row">
          <span className="xl-imp-res__lbl">Guia aerea</span>
          <span className="xl-imp-res__val xl-imp-res__mono xl-imp-res__break">{form.guia_aerea}</span>
        </div>
      )}
    </aside>
  );
}
